module.exports = __webpack_public_path__ + "media/Goals/ProtectNature-ee6f22e4.svg";